import { FunctionComponent } from 'react';

import SectionArticles from 'components/content/sections/Articles';
import { ArticleType } from 'components/content/sections/Articles/types';
import SectionsHeroBlack from 'components/content/sections/HeroBlack/component';
import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PageCoursesSectionHero: FunctionComponent<Props> = ({ translations, articles }) => {
    return (
        <StyledComponent className="page-blog-section-hero">
            <SectionsHeroBlack
                headline={translations?.headline}
                subheadline={translations?.subheadline}
            />
            <LayoutContainer size={Sizes.Large}>
                <div className="blog-main-news">
                    <SectionArticles
                        articleType={ArticleType.Single}
                        articles={articles}
                    />
                </div>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PageCoursesSectionHero;
